import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { apiEndpointURL } from '@app/core/constants/endpoints-url';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  private httpClient = inject(HttpClient);

  getInstitutionDetails(countryId?: any, paramsData?: any, filterDetails?: Map<string, string>): Observable<any> {
    let params = new HttpParams({});
    if (countryId)
      params = params.set('countryId', countryId);
    if (paramsData)
      Object.keys(paramsData).forEach(key => {
        if (paramsData[key])
          params = params.set(key, paramsData[key]);
      });
    if (filterDetails && filterDetails.size)
      filterDetails.forEach((value, key) => {
        params = params.set(key, value);
      });
    return this.httpClient.get(apiEndpointURL.getInstitutionEndpoint, { params });
  }
}
